<template>
  <div class="social">
    <div class="headTitle">
      <div class="shadowTxt">MEDIA</div>
      <div class="title">社交媒体</div>
    </div>
    <div class="contact">
      <MySelect :label="selectLabel" :data="selectData" @change="change" />
      <div class="weiXiImg"><img :src="src" alt="" /></div>
    </div>
  </div>
</template>
<script>
import { apiGetQrcode, apiGetQrcodeById } from "../../api/index";
import MySelect from "../../components/selectCom.vue";

export default {
  metaInfo: {
      title: '社交媒体-爱情地产',
      meta: [{
      name: 'keyWords',
      content: '爱情地产'
      },
      {
      name: 'description',
      content: ''
      }]
  },
  data() {
    return {
      backgroundTitle: "PROPERTY",
      title: "社交媒体",
      src: "",
      selectLabel: [
        {
          label: "集团",
          value: "集团",
          name: "area",
        },
        {
          label: "爱情地产微信",
          value: "爱情地产微信",
          name: "address",
        },
      ],
      selectData: {
        area: "",
        address: "",
      },
      areaData: [],
      options: [],
    };
  },
  components: {
    MySelect,
  },
  methods: {
    change(type, val) {
      this.selectLabel.forEach((item) => {
        if (item.name == type) item.value = val;
      });
      type == "area"
        ? this.changeCity(this.areaData.filter((fil) => fil.area == val)[0].area)
        : this.changeImg(val);
    },
    changeCity(val) {
      apiGetQrcodeById(val).then((data) => {
        if (data.data.status == 1) {
          this.src =
            "http://www.weaiove.com" + data.data.address[0].photo;
          this.selectData.address = data.data.address.map(
            (res) => res.department
          );
          this.options = data.data.address
          this.selectLabel[1].value = data.data.address[0].department;
        }
      });
    },
    changeImg(val) {
      this.options.forEach((item) => {
        if (item.department === val) {
          this.src = "http://www.weaiove.com" + item.photo;
        }
      });
    },
    init() {
      apiGetQrcode().then((data) => {
        if (data.data.status == 1) {
          this.selectLabel[0].value = data.data.area[0].area;
          this.selectData.area = data.data.area.map((res) => res.area);
          this.areaData = data.data.area;
          this.changeCity(data.data.area[0].area);
        }
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
}
img {
  width: 100%;
}
/deep/.el-input {
  margin-right: 0;
}

/deep/.el-input__inner {
  border: none;
  text-align: center;
}
.headTitle {
  padding: 20px 15px 7px 15px;
  background: #fff;
  .shadowTxt {
    font-size: 40px;
    line-height: 47px;
    color: #f8f8f8;
    font-family: "DIN Alternate Bold";
    font-weight: bold;
  }
  .title {
    color: #222;
    font-size: 18px;
    line-height: 25px;
    font-family: "苹方-简 中黑体";
    font-weight: 600;
    margin-top: -28px;
  }
}
.contact {
  .contSelect {
    padding: 13px 0;
    border-top: 1px solid #efefef;
    border-bottom: 1px solid #efefef;
    color: #666;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    .group,
    .weiXi {
      font-size: 14px;
      line-height: 20px;
      span {
        width: 8px;
        height: 8px;
        display: inline-block;
        margin-left: 5px;
        margin-bottom: 3px;
        img {
          display: flex;
        }
      }
    }

    .line {
      width: 1px;
      height: 19px;
      background: #efefef;
    }
  }
  .weiXiImg {
    padding: 35px 88px 43px 87px;
  }
}
</style>
